export default {
  title: "Regra tipo 7 - Quantidade de áreas em um projeto",
  subtitle: "Qual a quantidade recomendada de áreas distintas alocadas em um único projeto? O valor informado é aplicado para projetos pequenos, e com base nele para os demais.",
  token: "areas_per_project",
  button: {
    trigger: 1,
  },
  tables: [
    {
      type: "general",
      title: "Regra geral",
      actions: "edit_remove",
      columns: [
        {
          label: "Quantidade",
          key: "value_c",
          type: "priority",
        },
      ],
      data: [],
    },
  ],
  drawer: {
    title: {
      insert_label: "Adicionar Regra",
      update_label: "Editar Regra",
    },
    subtitle: "Regra tipo 7 - Quantidade de áreas em um projeto",
    form: [
      {
        label: "Informe a quantidade:",
        type: "numberOfAreas",
        key: "value_c",
        placeholder: "",
        value: "*",
        visible: false,
      },
    ],
  },
};
